var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgSearch = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8045 15.8635L12.2545 11.3135C13.1359 10.2248 13.6665 8.84146 13.6665 7.33481C13.6665 3.84281 10.8252 1.00146 7.33324 1.00146C3.84128 1.00146 1 3.84278 1 7.33478C1 10.8268 3.84131 13.6681 7.33327 13.6681C8.83991 13.6681 10.2232 13.1375 11.3119 12.2561L15.8618 16.8061C15.9918 16.9361 16.1625 17.0015 16.3332 17.0015C16.5039 17.0015 16.6745 16.9361 16.8045 16.8061C17.0652 16.5455 17.0652 16.1241 16.8045 15.8635ZM7.33327 12.3348C4.57596 12.3348 2.33333 10.0921 2.33333 7.33478C2.33333 4.57743 4.57596 2.33478 7.33327 2.33478C10.0906 2.33478 12.3332 4.57743 12.3332 7.33478C12.3332 10.0921 10.0906 12.3348 7.33327 12.3348Z",
    fill: "current"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSearch, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/search.b39ff2f4.svg";
export { ForwardRef as ReactComponent };